"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSuggestedCropToCropAreaState = exports.toCropAreaState = void 0;
var ImageInfo_1 = require("../../ImageInfo");
function toCropAreaState(imageInfo) {
    var _a, _b;
    var sourceImageInfo = imageInfo.srcid ? imageInfo.srcImageInfo : imageInfo;
    var edits = (_a = imageInfo.markupState) === null || _a === void 0 ? void 0 : _a.edits;
    if (!edits) {
        return null;
    }
    if ((0, ImageInfo_1.isNodeMarkupEditsState)(edits)) {
        var nodeMarkupCrop = (_b = edits.data) === null || _b === void 0 ? void 0 : _b.crop;
        return {
            flippedHorizontally: false,
            flippedVertically: false,
            rotationAngle: 0,
            height: sourceImageInfo.height,
            width: sourceImageInfo.width,
            cropRect: {
                // The CROPRO editor expects a 20px offset to the crop coordinates
                x: nodeMarkupCrop.x + 20,
                y: nodeMarkupCrop.y + 20,
                width: nodeMarkupCrop.width,
                height: nodeMarkupCrop.height,
            },
        };
    }
    else if ((0, ImageInfo_1.isCroproEditsState)(edits)) {
        return edits.data;
    }
    // Edits type isn't implemented!
    return null;
}
exports.toCropAreaState = toCropAreaState;
function convertSuggestedCropToCropAreaState(imageInfo) {
    var sourceImageInfo = imageInfo.srcImageInfo || imageInfo;
    var suggestedCrop = sourceImageInfo.suggestedCrop;
    if (suggestedCrop) {
        return {
            flippedHorizontally: false,
            flippedVertically: false,
            rotationAngle: 0,
            height: sourceImageInfo.height,
            width: sourceImageInfo.width,
            cropRect: {
                height: suggestedCrop.height,
                width: suggestedCrop.width,
                // The CROPRO editor expects a 20px offset to the crop coordinates
                x: suggestedCrop.x + 20,
                y: suggestedCrop.y + 20,
            },
        };
    }
    return null;
}
exports.convertSuggestedCropToCropAreaState = convertSuggestedCropToCropAreaState;
